/*
 * @Author: zhaotao
 * @Version:
 * @Date: 2023-06-27 09:22:36
 * @Description:
 */
import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';
export default (function (params) {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '',
    name: 'deviceUtilizationTrendGet',
    method: 'GET',
  });
  useEffect(() => {
    if (params) {
      let url = `/api/device/utilization/trend`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return [isRequestSuccessed, data || [], exec, isLoading];
});
